import { HTTPService } from '../HTTPService/HTTPService';

interface Dependencies {
    httpService: HTTPService;
}

export class SettingService {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async getMaxAmount(): Promise<number> {
        const url = 'settings/max-amount';
        const res = await this.httpService.get({
            url,
        });
        return res.data;
    }
}
